<template>
  <calm-page extra-class="profile-pw" :title="$t('profile.change_password')">
    <!-- Single centered narrow form. Logic preserved verbatim: the two
         base-inputs keep their v-model, and the save button keeps its inline
         v-if password-match / length gating + @click handler (§349 chrome-only). -->
    <div class="profile-pw__wrap">
      <form class="profile-pw__form" @submit.prevent>
        <calm-form-section :num="1" :title="$t('profile.change_password')">
          <div class="calm__form-grid calm__form-grid--1">
            <calm-form-row :label="$t('profile.password_new')">
              <base-input
                type="password"
                placeholder=""
                v-model="password"
              ></base-input>
            </calm-form-row>

            <calm-form-row :label="$t('profile.password_confirm')">
              <base-input
                type="password"
                autocomplete=""
                placeholder=""
                id="password_confirm"
                v-model="password_confirm"
              />
            </calm-form-row>
          </div>
        </calm-form-section>

        <div class="profile-pw__actions">
          <calm-button
            variant="primary"
            native-type="submit"
            :disabled="(password != password_confirm || password.length <= 4) ? true : false"
            @click="handleUpdate()"
          >
            {{ $t("save") }}
          </calm-button>
        </div>
      </form>
    </div>
  </calm-page>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import numbers from "./numbers";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CreateNumber",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    ...mapGetters({
      isCorporateAdmin: "Auth/isCorporateAdmin",
      isDtacAdmin: "Auth/isDtacAdmin",
      isReadOnly: "Auth/isReadOnly",
      corporate: "Corporate/getData"
    })
  },
  data() {
    return {
      optionChargeNumber: [
        {
          label: this.$t("menu.pilot_number"),
          value: 1
        },
        {
          label: this.$t("menu.agent_number"),
          value: 2
        }
      ],

        password: "",
        password_confirm: ""
    };
  },
  mounted() {
  },
  methods: {
    ...mapActions({
      changePassword: "Auth/changePassword"
    }),

    handleUpdate() {
      this.changePassword({
        password : this.password,
        confirm_password :this.password_confirm
      })
        .then(resp => {
          swal
            .fire({
              title: this.$t("profile.change_password_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            })
            .then(result => {
              
            });
        })
        .catch(err => {
          swal.fire({
            title: this.$t("errors.profile.change_password_failed"),
            text: this.getErrorText(err.response.data),
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    }
  }
};
</script>

<style scoped>
/* Change-password — Calm skin. Everything namespaced under .profile-pw so
   nothing leaks. Chrome-only: the form keeps its base-input v-model bindings
   and the save button's inline password-match / length gating (see template). */

/* A single, centered, narrow form column. */
.profile-pw__wrap {
  display: flex;
  justify-content: center;
}
.profile-pw__form {
  width: 100%;
  max-width: 520px;
}

/* Action row pinned under the field column, right-aligned. */
.profile-pw__actions {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* Drop the base-input's own bottom margin — calm-form-row owns the spacing. */
.profile-pw >>> .form-group {
  margin-bottom: 0;
}
/* base-input renders its own <label>; we use calm-form-row's label instead,
   so hide the inner one to avoid a doubled label. */
.profile-pw >>> .form-group > label {
  display: none;
}
</style>
